import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import SensorsIcon from "@mui/icons-material/Sensors";
import PersonIcon from "@mui/icons-material/Person";
import SsidChartIcon from "@mui/icons-material/SsidChart";
import { useLocation, useNavigate } from "react-router-dom";
import { List } from "@mui/material";

export const MenuList = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <List component="nav">
      <ListItemButton
        selected={pathname === "/laitteet"}
        onClick={() => navigate("/laitteet")}
      >
        <ListItemIcon>
          <SensorsIcon />
        </ListItemIcon>
        <ListItemText primary="Laitteet" />
      </ListItemButton>
      <ListItemButton
        selected={pathname === "/lämpötilat" || pathname === "/"}
        onClick={() => navigate("/lämpötilat")}
      >
        <ListItemIcon>
          <SsidChartIcon />
        </ListItemIcon>
        <ListItemText primary="Lämpötilahistoria" />
      </ListItemButton>
      <ListItemButton
        selected={pathname === "/käyttäjätili"}
        onClick={() => navigate("/käyttäjätili")}
      >
        <ListItemIcon>
          <PersonIcon />
        </ListItemIcon>
        <ListItemText primary="Käyttäjätili" />
      </ListItemButton>
    </List>
  );
};
